/**
 * @file: useOrderDraftModal.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useOrderFlowContext } from '@euler/app/flows/order/OrderFlowContext';
import { useBehaviorSubject } from '@euler/utils/hooks';
import { useCallback } from 'react';

export const useOrderDraftModal = () => {
  const { showDraftModal$ } = useOrderFlowContext();
  const [visible] = useBehaviorSubject(showDraftModal$);
  const onDismiss = useCallback(() => {
    showDraftModal$.next(false);
  }, [showDraftModal$]);
  return { visible, onDismiss };
};
